const calpak = window.calpak

/**
 * Gets keyboard-focusable elements within a specified element
 * 
 * @see https://zellwk.com/blog/keyboard-focusable-elements/
 * @see https://allyjs.io/data-tables/focusable.html
 * @param {HTMLElement} [element=document] element
 * @returns {Array}
 */
function getKeyboardFocusableElements(element = document) {
    return [
        ...element.querySelectorAll(
            'a[href],button,input,textarea,select,details,[tabindex]:not([tabindex="-1"]),.slide,[data-focusable]'
        ),
    ].filter(
        el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden')
    )
}

window.addEventListener("click", (e) => {
    if (!e.target.classList.contains('slider__control')) {
        return;
    }

    e.preventDefault();
    let wrapper = e.target.closest('.slider__wrapper');
    if(!wrapper) return;
    let gap = 0;
    let slideNum = 1;
    const btnPrev = wrapper.querySelector('.slider__control--prev');
    const btnNext = wrapper.querySelector('.slider__control--next');
    let isInfinite = false;
    
    if(btnPrev){
        isInfinite = btnPrev.dataset.isInfinite === 'true';
        btnPrev.setAttribute('aria-label', 'Previous slide');
    }
    if(btnNext){
        isInfinite = btnNext.dataset.isInfinite === 'true';
        btnNext.setAttribute('aria-label', 'Next slide');
    }

    if(wrapper.hasAttribute('data-gap')) gap = Number(wrapper.getAttribute('data-gap'));
    if(wrapper.hasAttribute('data-slide')) slideNum = Number(wrapper.getAttribute('data-slide'));
    if(window.innerWidth <= 900 && wrapper.hasAttribute('data-slide-mob')) slideNum = Number(wrapper.getAttribute('data-slide-mob'));
    let slider = wrapper.querySelector('.slider');
    let firstSlide = slider.querySelector('.slide:not(.related-upsell):not(.hidden)');

    if(!firstSlide) firstSlide = slider.querySelector('*');

    let slideWidth = firstSlide.offsetWidth;
    let currentScroll = slider.scrollLeft;
    let maxScroll = slider.scrollWidth - slider.clientWidth;
    let maxPage = Math.round(maxScroll / slideWidth);
    let currentPage = Math.round(currentScroll / slideWidth);

    if(e.target.classList.contains('slider__control--next')) {
        if(currentPage < maxPage) {
            currentPage += slideNum;
            currentScroll = currentPage * slideWidth + gap * currentPage;
            slider.scrollLeft = currentScroll;
        } else if(currentPage >= maxPage) {
            currentPage = maxPage;
            currentScroll = maxScroll;
            slider.scrollLeft = maxScroll;
            if(isInfinite){
                currentPage = 0;
                currentScroll = 0;
                slider.scrollLeft = 0;
            }
        }
        
    } else if(e.target.classList.contains('slider__control--prev')) {
        if(currentScroll >= 0) currentPage -= slideNum;
        if(currentPage < 0) {
            if(isInfinite) currentPage = maxPage;
            else currentPage = 0;
        }

        currentScroll = currentPage * slideWidth + gap * currentPage;
        slider.scrollLeft = currentScroll;
    }

    if (!isInfinite) {
        if (maxScroll - currentScroll < 20) {
            wrapper.classList.add('slider__wrapper--end');
            wrapper.classList.remove('slider__wrapper--start');
        } else {
            wrapper.classList.remove('slider__wrapper--end');
        }

        if (currentPage == 0) {
            wrapper.classList.add('slider__wrapper--start');
            wrapper.classList.remove('slider__wrapper--end');
        } else {
            wrapper.classList.remove('slider__wrapper--start');
        }

        if(btnPrev){
            if (wrapper.classList.contains('slider__wrapper--start')){
                btnPrev.setAttribute('disabled', 'disabled');
                btnPrev.setAttribute('aria-hidden', 'true');
                btnPrev.setAttribute('tabindex', '-1');
            } else {
                btnPrev.removeAttribute('disabled');
                btnPrev.removeAttribute('aria-hidden');
                btnPrev.removeAttribute('tabindex');
            }
        }
        if(btnNext){
            if (wrapper.classList.contains('slider__wrapper--end')){
                btnNext.setAttribute('disabled', 'disabled');
                btnNext.setAttribute('aria-hidden', 'true');
                btnNext.setAttribute('tabindex', '-1');
            } else {
                btnNext.removeAttribute('disabled');
                btnNext.removeAttribute('aria-hidden');
                btnNext.removeAttribute('tabindex');
            }
        }
    } else {
        wrapper.classList.remove('slider__wrapper--end', 'slider__wrapper--start');
        if(btnPrev){
            btnPrev.removeAttribute('disabled');
            btnPrev.removeAttribute('aria-hidden');
            btnPrev.removeAttribute('tabindex');
        }
        if(btnNext){
            btnNext.removeAttribute('disabled');
            btnNext.removeAttribute('aria-hidden');
            btnNext.removeAttribute('tabindex');
        }
    }
});

function moveToSlide(slider, currentPage = 0, sliderCheckNum = 0) {

    let wrapper = slider.closest('.slider__wrapper');
    let gap = 0;
    if(wrapper.hasAttribute('data-gap')) gap = Number(wrapper.getAttribute('data-gap'));
    const slides = slider.querySelectorAll('.slide:not(.related-upsell)');
    let firstSlide = slides[sliderCheckNum];
    let vertical = slider.classList.contains('slider--vertical') || (slider.classList.contains('slider--vertical-on-desktop') && window.innerWidth > 900);

    let maxScroll = 0;

    if(vertical) maxScroll = slider.scrollHeight - slider.clientHeight;
    else maxScroll = slider.scrollWidth - slider.clientWidth;

    if(maxScroll == 0) return;

    if(!firstSlide) firstSlide = slider.querySelector('*');

    let slideWidth = 0;

    if(vertical) {
        slideWidth = firstSlide.offsetHeight;
    } else {
        slideWidth = firstSlide.offsetWidth;
    }

    let currentScroll = (slideWidth + gap) * currentPage;

    if(vertical) {
        slider.scrollTop = currentScroll;
    } else {
        slider.scrollLeft = currentScroll;
    }

    if(maxScroll - currentScroll < 20) {
        wrapper.classList.add('slider__wrapper--end');
        wrapper.classList.remove('slider__wrapper--start');
    } else {
        wrapper.classList.remove('slider__wrapper--end');
    }

    if(currentPage == 0) {
        wrapper.classList.add('slider__wrapper--start');
        wrapper.classList.remove('slider__wrapper--end');
    } else wrapper.classList.remove('slider__wrapper--start');
}

function sliderThumbClick(thumb, indexFilter = false, sliderCheckNum = 0) {
    const slider = thumb.closest('.slider');
    const actives = slider.querySelectorAll('.slide--selected');
    if(actives.length > 0) actives.forEach(active => {
        active.classList.remove('slide--selected')
        active.removeAttribute('aria-current');
    });

    thumb.classList.add('slide--selected');
    thumb.setAttribute('aria-current', 'true');

    let index = calpak.getIndexWithSelector(thumb, '.slide:not(.related-upsell)');
    if(indexFilter !== false) index = indexFilter(index);

    moveToSlide(document.querySelector(slider.getAttribute('data-nav-for')), index, sliderCheckNum);
}

calpak.sliderThumbClick = sliderThumbClick;

function isSafari() {
    return (
        navigator.userAgent.indexOf("Safari") > -1 &&
        navigator.userAgent.indexOf("Chrome") === -1
    );
}

const checkSlider = function(slider, sliderCheckNum = 0, indexFilter = false) {
    if(!slider) return;
    let wrapper = slider.closest('.slider__wrapper');
    if(!wrapper) return;
    // console.log('checkSlider')

    const slides = slider.querySelectorAll('.slide:not(.related-upsell)');
    let firstSlide = slides[sliderCheckNum];
    if(!firstSlide) firstSlide = slider.querySelector('*');
    if(!firstSlide) return;
    
    const btnPrev = wrapper.querySelector('.slider__control--prev');
    const btnNext = wrapper.querySelector('.slider__control--next');
    let isInfinite = false; 
    
    if(btnPrev)
        isInfinite = btnPrev.dataset.isInfinite === 'true';
    if(btnNext)
        isInfinite = btnNext.dataset.isInfinite === 'true';

    let slideWidth = 0;
    let vertical = slider.classList.contains('slider--vertical') || (slider.classList.contains('slider--vertical-on-desktop') && window.innerWidth > 900);

    let currentScroll = 0;
    let maxScroll = 0;

    if(vertical) {
        currentScroll = Math.ceil(slider.scrollTop);
        maxScroll = slider.scrollHeight - slider.clientHeight;
        slideWidth = firstSlide.offsetHeight;
    } else {
        currentScroll = Math.ceil(slider.scrollLeft);
        maxScroll = slider.scrollWidth - slider.clientWidth;
        slideWidth = firstSlide.offsetWidth;
    }

    let maxPage = Math.round(maxScroll / slideWidth);
    let currentPage = Math.round(currentScroll / slideWidth);
    if(isNaN(currentPage)) currentPage = 0;

    if (slider.scrollWidth === 0 && slider.clientWidth === 0 && firstSlide.offsetWidth === 0) {
        return;
    }

    // let animateScroller = isSafari() || wrapper.classList.contains('slider__wrapper--content-slider');

    if(!wrapper.classList.contains('slider__wrapper--loaded')) {
        slider.addEventListener('scroll', function() {
            if(sliderThrottle !== false) clearTimeout(sliderThrottle);
            sliderThrottle = setTimeout(() => {
                const thisSlider = this;
                const currentScroll = Math.ceil(slider.scrollLeft);
                const firstSlide = slider.querySelector('*');
                const slideWidth = firstSlide.offsetWidth;
                const currentPage = Math.round(currentScroll / slideWidth);

                const event = new CustomEvent('sliderUpdate', {
                    bubbles: true,
                    detail: {
                        slider: thisSlider,
                        slideNumber: currentPage
                    }
                });
                document.dispatchEvent(event);

                checkSlider(thisSlider, sliderCheckNum, indexFilter)
            }, 305);

            // if(animateScroller) {
                requestAnimationFrame(() =>
                    wrapper.style.setProperty('--scroll-pos', slider.scrollLeft)
                );
            // }
        }, {passive: true});

        if (slider.classList.contains("slider-nav")) {
            slider.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    slider.querySelector('.slide--selected').nextElementSibling?.click();
                } else if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    slider.querySelector('.slide--selected').previousElementSibling?.click();
                } else if (e.key === 'Enter') {
                    e.preventDefault();
                    sliderThumbClick(e.target);
                }
            });
            slider.addEventListener('click', (e) => {
                if (e.target.classList.contains('slide')) {
                    sliderThumbClick(e.target);
                }
            });
        }

        if(slider.hasAttribute('data-autoslide')) {
            let autoslide = Number(slider.getAttribute('data-autoslide'));
            if(!isNaN(autoslide)) runSlider(slider, autoslide);
        }

        wrapper.classList.add('slider__wrapper--loaded');
    }

    if(slider.hasAttribute('data-nav')) {
        let nav = document.querySelector(slider.getAttribute('data-nav'));
        if(nav) {
            checkSlider(nav);

            let actives = nav.querySelectorAll('.slide--selected');
            if(actives.length > 0) actives.forEach(active => active.classList.remove('slide--selected'));

            let activate = nav.querySelectorAll('.slide:not(.related-upsell)');

            if(indexFilter !== false &&  activate[indexFilter(currentPage)]) activate[indexFilter(currentPage)].classList.add('slide--selected');
            else if (activate[currentPage]) activate[currentPage].classList.add('slide--selected');
        }
    }

    
    if (!isInfinite) {
        if (maxScroll - currentScroll < 20) {
            wrapper.classList.add('slider__wrapper--end');
            wrapper.classList.remove('slider__wrapper--start');
        } else {
            wrapper.classList.remove('slider__wrapper--end');
        }

        if (currentPage == 0) {
            wrapper.classList.add('slider__wrapper--start');
            wrapper.classList.remove('slider__wrapper--end');
        } else {
            wrapper.classList.remove('slider__wrapper--start');
        }

        if(btnPrev){
            if (wrapper.classList.contains('slider__wrapper--start')){
                btnPrev.setAttribute('disabled', 'disabled');
                btnPrev.setAttribute('aria-hidden', 'true');
                btnPrev.setAttribute('tabindex', '-1');
            } else {
                btnPrev.removeAttribute('disabled');
                btnPrev.removeAttribute('aria-hidden');
                btnPrev.removeAttribute('tabindex');
            }
        }

        if(btnNext){
            if (wrapper.classList.contains('slider__wrapper--end')){
                btnNext.setAttribute('disabled', 'disabled');
                btnNext.setAttribute('aria-hidden', 'true');
                btnNext.setAttribute('tabindex', '-1');
            } else {
                btnNext.removeAttribute('disabled');
                btnNext.removeAttribute('aria-hidden');
                btnNext.removeAttribute('tabindex');
            }
        }
    } else {
        wrapper.classList.remove('slider__wrapper--end', 'slider__wrapper--start');
        if(btnPrev){
            btnPrev.removeAttribute('disabled');
            btnPrev.removeAttribute('aria-hidden');
            btnPrev.removeAttribute('tabindex');
        }
        if(btnNext){
            btnNext.removeAttribute('disabled');
            btnNext.removeAttribute('aria-hidden');
            btnNext.removeAttribute('tabindex');
        }
    }

    if(maxScroll == 0) {
        wrapper.classList.add('slider__wrapper--end');
        wrapper.classList.add('slider__wrapper--start');
        return;
    }

    if(!isInfinite){
        if(maxScroll - currentScroll < 20) wrapper.classList.add('slider__wrapper--end');
        else wrapper.classList.remove('slider__wrapper--end');

        if(currentPage == 0) wrapper.classList.add('slider__wrapper--start');
        else wrapper.classList.remove('slider__wrapper--start');
    }
    let dots = wrapper.querySelectorAll('.slider__dot');
    if(dots.length) {
        for(let i = 0; i < dots.length; i++) {
            dots[i].removeAttribute('aria-current');
            dots[i].classList.remove('slider__dot--active');
        };
        if(dots.length <= currentPage) currentPage -= dots.length;
        dots[currentPage].classList.add('slider__dot--active');
        dots[currentPage].setAttribute('aria-current', 'true');
    }

    a11yObserver(slider);
}
calpak.checkSlider = checkSlider

let sliderThrottle = false;
const sliderHandler = () => {
    let sliders;
    if(document.body.classList.contains("template-page-about")){
        sliders = document.querySelectorAll(".template-page-about .slider");
    } else {
        sliders = document.querySelectorAll(".slider:not(.product-unit__swatches.swatches-container.slider)");
    }
    const observer = new IntersectionObserver(function(entries){
        entries.forEach(entry => {
            if (entry.intersectionRatio === 0) {
                return;
            }
            // entry.target.style.opacity = entry.intersectionRatio;

            observer.unobserve(entry.target);
            const slider = entry.target;
            const vertical = slider.classList.contains('slider--vertical') || (
                slider.classList.contains('slider--vertical-on-desktop')
                    && window.innerWidth > 900
            );
            
            slider.classList.add('scrolling-back');
            
            if (vertical) {
                slider.scrollTop = 0;
            } else {
                slider.scrollLeft = 0;
            }

            setTimeout(() => slider.classList.remove('scrolling-back'), 10);

            checkSlider(slider);
        });
    }, {
        threshold: 0,
        rootMargin: '0px'
    });

    sliders.forEach(slider => {
        checkSlider(slider);
        observer.observe(slider);
    });
};

const a11yObserver = (carousel) => {
    const slides = carousel.querySelectorAll('.slide:not(.related-upsell)');
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            const slide = entry.target;

            if (slide.parentNode.closest('.slide[aria-hidden="true"],.slide[tabindex="-1"]') !== null) {
                return;
            }

            if (entry.isIntersecting === false) {
                getKeyboardFocusableElements(slide).forEach(element => {
                    element.setAttribute('tabindex', '-1');
                });
            } else {
                slide.removeAttribute('aria-hidden');
                getKeyboardFocusableElements(slide).forEach(element => {
                    element.removeAttribute('tabindex');
                });
            }
        });
    }, {
        root: carousel,
        rootMargin: '0px',
        threshold: [0.80],
    });

    const totalSlides = slides.length;
    if(totalSlides == 0)
        return;
    const slideWidth = slides[0].offsetWidth;
    const totalWidth = slideWidth * totalSlides;
    const backSlide = carousel.querySelector('.slide.back');
    const frontSlide = carousel.querySelector('.slide.front');

    if (carousel.parentElement.classList.contains('slider__wrapper--infinite') && frontSlide && backSlide) {
        let isScrolling = false;
        let lastTriggeredSlide = null;
        let isInitialLoad = true;
        let initialScrollDone = false;

        if (!carousel.classList.contains('have-curtain')){
            carousel.classList.add('have-curtain');

            const blocker = document.createElement('div');
            blocker.classList.add('curtain');
            blocker.style.position = 'absolute';
            blocker.style.top = '0';
            blocker.style.left = '0';
            blocker.style.right = '0';
            blocker.style.bottom = '0';
            blocker.style.zIndex = '1000';
            blocker.style.display = 'none';
            carousel.style.position = 'relative';
            carousel.parentNode.appendChild(blocker);
        }
        
        const edgeObserver = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                const slide = entry.target;

                if (entry.isIntersecting && !isScrolling && slide !== lastTriggeredSlide) {
                    if (isInitialLoad && !initialScrollDone) {
                        initialScrollDone = true;
                        carousel.scrollTo({
                            left: slideWidth,
                            behavior: 'auto'
                        });
                        isInitialLoad = false;
                        return;
                    }
                    
                    if (isInitialLoad) {
                        return;
                    }

                    isScrolling = true;
                    lastTriggeredSlide = slide;
                    carousel.style.scrollBehavior = 'auto';

                    const curtain = carousel.parentElement.querySelector('.curtain');
                    if (curtain) curtain.style.display = 'block';

                    edgeObserver.disconnect();
        
                    if (slide.classList.contains('front')) {
                        carousel.scrollTo({
                            left: totalWidth - slideWidth * 2,
                            behavior: 'auto'
                        });
                    }
                    if (slide.classList.contains('back')) {
                        carousel.scrollTo({
                            left: slideWidth,
                            behavior: 'auto'
                        });
                    }

                    setTimeout(() => {
                        if (backSlide) edgeObserver.observe(backSlide);
                        if (frontSlide) edgeObserver.observe(frontSlide);

                        isScrolling = false;
                        lastTriggeredSlide = null;

                        curtain.style.display = 'none';
                    }, 100); 
                }
            });
        }, {
            root: carousel,
            rootMargin: '0px',
            threshold: [0.98],
        });
        
        if (backSlide) edgeObserver.observe(backSlide);
        if (frontSlide) edgeObserver.observe(frontSlide);
    }

    slides.forEach(slide => {
        observer.observe(slide);
    });

    carousel.observer?.disconnect();
    carousel.observer = observer;
};

function runSlider(slider, autoslide) {
    const wrapper = slider.closest('.slider__wrapper');
    const playpause = wrapper.querySelector('.slider__playpause');
    playpause.addEventListener('click', e => {
        e.preventDefault();
        if (!playpause.classList.contains('slider__playpause--paused')) {
            playpause.classList.add('slider__playpause--paused');
            playpause.setAttribute("aria-label", "Play slide rotation");
        } else {
            playpause.classList.remove('slider__playpause--paused');
            playpause.setAttribute("aria-label", "Pause slide rotation");
        }
    });
    playpause.addEventListener('keydown', e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            playpause.click();
        }
    });

    setInterval(function() {
        if (wrapper.matches(':hover,:focus-within')) {
            return;
        }

        if (playpause && playpause.classList.contains('slider__playpause--paused')) {
            return;
        }

        let vertical = slider.classList.contains('slider--vertical') || (slider.classList.contains('slider--vertical-on-desktop') && window.innerWidth > 900);
        let slideWidth = 0;
        let currentScroll = slider.scrollLeft;
        if(vertical) currentScroll = slider.scrollTop;

        let maxScroll = 0;

        if(vertical) {
            maxScroll = slider.scrollHeight - slider.clientHeight;
            slideWidth = slider.offsetHeight;
        } else {
            maxScroll = slider.scrollWidth - slider.clientWidth;
            slideWidth = slider.offsetWidth;
        }

        let gap = 0;
        if(wrapper && wrapper.hasAttribute('data-gap')) gap = Number(wrapper.getAttribute('data-gap'));

        let maxPage = Math.round(maxScroll / slideWidth);
        let currentPage = Math.round(currentScroll / slideWidth);

        currentPage++;

        if(vertical) slider.scrollTop = currentPage * slideWidth + gap;
        else slider.scrollLeft = currentPage * slideWidth + gap;

        if(currentPage >= maxPage) {
            currentPage = 0;
            setTimeout(function() {
                slider.classList.add('scrolling-back');
                if(vertical) setTimeout(() => slider.scrollTop = 0, 50);
                else setTimeout(() => slider.scrollLeft = 0, 50);
                setTimeout(() => slider.classList.remove('scrolling-back'), 50);
            }, 1000);
        }

        let dots = wrapper.querySelectorAll('.slider__dot');

        if (!dots.length) {
            return;
        }

            for(let i = 0; i < dots.length; i++){
                dots[i].classList.remove('slider__dot--active');
                dots[i].removeAttribute('aria-current');
                dots[currentPage].classList.add('slider__dot--active');
                dots[currentPage].setAttribute('aria-current', 'true');
                const slides = document.querySelectorAll('.reviews__slider .reviews__slide');
                for(let i = 0; i < slides.length; i++){
                    if(slides[i].getAttribute('data-index') == currentPage) {
                        slides[i].classList.add('reviews__slide--active');
                    } else {
                        slides[i].classList.remove('reviews__slide--active');
                    }
                }
            }

    }, autoslide * 1000);

}

// window.addEventListener("DOMContentLoaded", ()=> {
document.addEventListener("calpak:ready", () => {

    sliderHandler()

    const sliderDots = document.querySelectorAll('.slider__dot');
    if(sliderDots.length > 0) sliderDots.forEach(sliderDot => {
        sliderDot.addEventListener('click', e => {
        let index = 0;
        let dots = e.target.parentNode.querySelectorAll('.slider__dot');
        let wrapper = e.target.closest('.slider__wrapper');
        if(!wrapper) return;
    
        for(let i = 0; i < dots.length; i++) {
            if(dots[i] == e.target) {
                index = i;
                dots[i].classList.add('slider__dot--active');
                dots[i].setAttribute('aria-current','true');
            } else {
                dots[i].classList.remove('slider__dot--active');
                dots[i].removeAttribute('aria-current');
            }
        }
    
        moveToSlide(wrapper.querySelector('.slider'), index);
        });
    
        sliderDot.addEventListener('keydown', e => {
            if (e.key === 'Enter') {
                e.preventDefault();
                sliderDot.click();
            }
        });
    });
    
    const changeSlides = e => {
        let dots = e.target.parentNode.parentNode.querySelectorAll('.slider__dot');
        let wrapper = e.target.closest('.slider__wrapper');
    
        if (!wrapper) return;
        const clickedDotIndex = parseInt(e.target.getAttribute('data-index') || "0");
        for (let i = 0; i < dots.length; i++) {
            const dot = dots[i];
            const index = parseInt(dot.getAttribute('data-index') || "0");
            if (index === clickedDotIndex) {
                dot.classList.add('slider__dot--active');
                dot.setAttribute('aria-current', 'true');
            } else {
                dot.classList.remove('slider__dot--active');
                dot.removeAttribute('aria-current');
            }
        }
    
        moveToSlide(wrapper.querySelector('.slider'), clickedDotIndex);
    };
    
    if (sliderDots.length > 0) {
        sliderDots.forEach(sliderDot => sliderDot.addEventListener('click', changeSlides));
    }

    function isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    if(isMobileDevice()){
      const sliders = document.querySelectorAll(".image-video-slider .slider.slider--scrollbar, .featured-col__lists .slider.slider--scrollbar, .promo-collection__products.slider.slider--scrollbar, .pdp__upsell .slider.slider--scrollbar, .filter__collections.slider.slider--scrollbar, .collections-menu, .content-blocks .slider.slider--scrollbar, .custom-reviews-slider .slider.slider--scrollbar");
      sliders.forEach(slider=>{
        // if(slider.scrollWidth - slider.clientWidth <= 0)
        //     return;
        const scrollbar = document.createElement("div");
        scrollbar.classList.add("custom-scrollbar");
        const scrollbarThumb = document.createElement("div");
        scrollbarThumb.classList.add("custom-scrollbar-thumb");
        scrollbar.appendChild(scrollbarThumb);
        slider.parentElement.appendChild(scrollbar)
        scrollbarThumb.style.left = `calc(var(--scroll-pos) / ${slider.scrollWidth - slider.clientWidth} * ${scrollbar.clientWidth - scrollbarThumb.clientWidth}px)`;
        let isDragging = false;
        let startX;
        let scrollLeftStart;
        let thumbPos = 0;
  
        scrollbarThumb.addEventListener('touchstart', (e) => {
          isDragging = true;
          startX = e.touches[0].pageX;
          scrollLeftStart = slider.scrollLeft;
          thumbPos = scrollbarThumb.offsetLeft;
          e.preventDefault(); // Prevent scrolling the page
        }, { passive: false });
  
        scrollbarThumb.addEventListener('touchmove', (e) => {
          if (!isDragging) return;
          const touchX = e.touches[0].pageX;
          const moveX = touchX - startX;
          slider.scrollLeft = scrollLeftStart + moveX / (scrollbar.clientWidth) * slider.scrollWidth;
          let pos = thumbPos + moveX;
          if(pos<=0)
            pos = 0;
          if(pos >= scrollbar.clientWidth - scrollbarThumb.clientWidth )
            pos = scrollbar.clientWidth - scrollbarThumb.clientWidth;
          scrollbarThumb.style.left = pos + "px";
        }, { passive: false });
  
        scrollbarThumb.addEventListener('touchend', () => {
          isDragging = false;
         scrollbarThumb.style.left = `calc(var(--scroll-pos) / ${slider.scrollWidth - slider.clientWidth} * ${scrollbar.clientWidth - scrollbarThumb.clientWidth}px)`;
        });
      })
    }
})
  
  